// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as SessionsType$OrcaPaymentPage from "../Types/SessionsType.bs.js";

function useIsApplePayDelayedSessionFlow() {
  var sessions = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.sessions);
  return React.useMemo((function () {
                var sessionObj;
                sessionObj = typeof sessions !== "object" ? ({}) : (
                    sessions.TAG === "Loaded" ? sessions._0 : ({})
                  );
                var dict = Utils$OrcaPaymentPage.getDictFromJson(sessionObj);
                var applePaySessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "ApplePayObject");
                var applePayToken = SessionsType$OrcaPaymentPage.getPaymentSessionObj(applePaySessionObj.sessionsToken, "ApplePay");
                var applePayThirdPartyToken;
                applePayThirdPartyToken = applePayToken.TAG === "ApplePayTokenOptional" ? applePayToken._0 : undefined;
                return Core__Option.getOr(Core__Option.map(applePayThirdPartyToken, (function (token) {
                                  return Utils$OrcaPaymentPage.getDecodedBoolFromJson(token, (function (tokenObj) {
                                                return tokenObj["delayed_session_token"];
                                              }), false);
                                })), false);
              }), [sessions]);
}

function useIsGooglePayDelayedSessionFlow() {
  var sessions = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.sessions);
  return React.useMemo((function () {
                var sessionObj;
                sessionObj = typeof sessions !== "object" ? ({}) : (
                    sessions.TAG === "Loaded" ? sessions._0 : ({})
                  );
                var dict = Utils$OrcaPaymentPage.getDictFromJson(sessionObj);
                var googlePaySessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "GooglePayThirdPartyObject");
                var gPayToken = SessionsType$OrcaPaymentPage.getPaymentSessionObj(googlePaySessionObj.sessionsToken, "Gpay");
                var googlePayThirdPartyToken;
                googlePayThirdPartyToken = gPayToken.TAG === "GooglePayThirdPartyTokenOptional" ? gPayToken._0 : undefined;
                return Core__Option.getOr(Core__Option.map(googlePayThirdPartyToken, (function (token) {
                                  return Utils$OrcaPaymentPage.getDecodedBoolFromJson(token, (function (tokenObj) {
                                                return tokenObj["delayed_session_token"];
                                              }), false);
                                })), false);
              }), [sessions]);
}

export {
  useIsApplePayDelayedSessionFlow ,
  useIsGooglePayDelayedSessionFlow ,
}
/* react Not a pure module */
